import { abstractItems } from "@/api/abstractItems/useAbstractItemsQuery";
import { defects } from "@/api/defect/useDefectsQuery";
import { wmsLog } from "@/api/delivery/useDeliveryQuery";
import { department } from "@/api/department/useDepartmentQuery";
import { downtimeReasons } from "@/api/downtimeReasons/useDowntimeReasonsQuery";
import { equipments } from "@/api/equipment/useEquipmentQuery";
import { grades } from "@/api/grade/useGradesQuery";
import { inspections } from "@/api/inspect/inspectSpecification/useInspectionQuery";
import { specifications } from "@/api/inspect/inspectSpecification/useSpecificationsQuery";
import { inventories } from "@/api/inventories/useInventoriesQuery";
import { invoice } from "@/api/invoiceStatement/useInvoiceQuery";
import { itemCategories } from "@/api/itemCategories/useItemCategoriesQuery";
import { items } from "@/api/items/useItemQuery";
import { ledgers } from "@/api/ledgers/useLedgersQuery";
import { locations } from "@/api/locations/useLocationsQuery";
import { lots } from "@/api/lots/useLotsQuery";
import { molds } from "@/api/mold/useMoldQuery";
import { moldStocks } from "@/api/moldStock/useMoldStockQuery";
import { operations } from "@/api/operations/useOperationsQuery";
import { partners } from "@/api/partner/usePartnerQuery";
import { purchaseOrders } from "@/api/purchaseOrder/usePurchaseOrder";
import { routings } from "@/api/routing/useRoutingQuery";
import { routingOutsources } from "@/api/routingOutsource/useRoutingOutsourcesQuery";
import { sites } from "@/api/sites/useSitesQuery";
import { users } from "@/api/users/useUsersQuery";
import { wipInventory } from "@/api/wipInventories/useWipInventoriesQuery";
import { workLogsWorks } from "@/api/workLogsWorks/useWorkLogsWorksQuery";
import { customFunctions } from "@/config/customFunction";
import {
  abstractItemsHeader,
  defectsHeader,
  departmentHeader,
  downtimeReasonsHeader,
  equipmentsHeader,
  gradesHeader,
  inventoriesHeader,
  invoiceStatementHeader,
  itemCategoriesHeader,
  itemsBomHeader,
  itemsHeader,
  LedgersHeader,
  locationsHeader,
  lotsHeader,
  moldsHeader,
  moldStocksHeader,
  operationsHeader,
  orderHeader,
  partnersHeader,
  purchaseOrderItemsHeader,
  routingOutsourcesHeader,
  routingsHeader,
  sitesHeader,
  specificationsHeader,
  usersHeader,
  wipInventoriesHeader,
  wmsLogsHeader,
  workLogHeader,
} from "@/constants/columnHeader";
import ProtectedRoute from "@/features/Router/ProtectedRoute";
import { Layout } from "@/features/layout/Template";
import { LotTrackingProvider } from "@/features/lotTracking/context/LotTrackingProvider";
import ModalExample from "@/features/modal/example";
import { ProductionPlanCreateForm } from "@/features/productionPlan/form/CreateForm";
import { StandardLayoutProvider } from "@/features/standardLayout/Provider";
import { CheckboxProvider } from "@/features/workByManagement/context/CheckboxProvider";
import { KPIDefectPage } from "@/pages/KPI/kpi/defect";
import { KPILeadtimePage } from "@/pages/KPI/kpi/leadtime";
import { KPILeadTimeOrderPage } from "@/pages/KPI/kpi/leadtimeOrder";
import { KPIManhourPage } from "@/pages/KPI/kpi/manhour";
import { KPIPowerUsagePage } from "@/pages/KPI/kpi/powerUsage";
import { KPIRateOfOperationPage } from "@/pages/KPI/kpi/rateOfOperation";
import { KPIUPHPage } from "@/pages/KPI/kpi/uph";
import { AnalysisAbilityPage } from "@/pages/PMS/analysis/ability";
import { AnalysisErrorPage } from "@/pages/PMS/analysis/error";
import { AnalysisIdleTimePage } from "@/pages/PMS/analysis/idleTime";
import { AnalysisOutputPage } from "@/pages/PMS/analysis/output";
import { AnalysisPowerPage } from "@/pages/PMS/analysis/power";
import { AnalysisTotalOutputPage } from "@/pages/PMS/analysis/totaloutput";
import { AnalysisWorkTimePage } from "@/pages/PMS/analysis/workTime";
import { MonitoringPage } from "@/pages/PMS/monitoring";
import { PressCamViewPage } from "@/pages/PMS/press/camview";
import { PressClutchAndBrakePage } from "@/pages/PMS/press/clutchandbrake";
import { PressCompleteAdminPage } from "@/pages/PMS/press/completeAdmin";
import { PressErrorViewPage } from "@/pages/PMS/press/errorview";
import { PressFacilitiesPage } from "@/pages/PMS/press/facilities";
import { PressParameterViewPage } from "@/pages/PMS/press/parameterview";
import { PressDailyRegisterPage } from "@/pages/PMS/press/pressDailyRegister";
import { PressDailyStatusPage } from "@/pages/PMS/press/pressDailyStatus";
import { PressProblemPage } from "@/pages/PMS/press/problem";
import { PressMonitoringFactoryPage } from "@/pages/PMS/pressMonitoring/factory";
import { FactoryPageSetting } from "@/pages/PMS/pressMonitoring/factory/pageSetting";
import { AnalysisMonitoringPage } from "@/pages/analysisMonitoring";
import { BarcodeLiftPage } from "@/pages/barcodeLift";
import { BarcodeMergePage } from "@/pages/barcodeMerge";
import { ChangePointPage } from "@/pages/changePoint";
import { ChangePointListPage } from "@/pages/changePointList";
import { DailyListPage } from "@/pages/dailyList";
import { DailyRegisterPage } from "@/pages/dailyRegister";
import { MainDashboard } from "@/pages/dashboard";
import { DataDisplayPage } from "@/pages/dataDisplay";
import { DeliveryListCompanyPage } from "@/pages/deliveryListCompany";
import { DeliveryListHeadOfficePage } from "@/pages/deliveryListHeadOffice";
import { DeliveryListSupplierPage } from "@/pages/deliveryListSupplier";
import { DeliveryStatusHeadOfficePage } from "@/pages/deliveryStatusHeadOffice";
import { DeliveryStatusSupplierPage } from "@/pages/deliveryStatusSupplier";
import { DownTimeReasonsLogPage } from "@/pages/downtimeReasonsLog";
import { EquipmentAnalysisPage } from "@/pages/equipmentAnalysis";
import { EquipmentProblemPage } from "@/pages/equipmentProblem";
import { ErrorPage } from "@/pages/error";
import { ErrorViewPage } from "@/pages/errorView";
import { IdleTimePage } from "@/pages/idleTime";
import { InventoryPage } from "@/pages/inventoryManagement/inventory";
import { InventoryLifePage } from "@/pages/inventoryManagement/inventoryLife";
import { LackSafetyPage } from "@/pages/inventoryManagement/lackSafety";
import { LedgerAllPage } from "@/pages/inventoryManagement/ledgersAll";
import { WipInventoryPage } from "@/pages/inventoryManagement/wipInventory";
import { WmsLogsPage } from "@/pages/inventoryManagement/wmsLogs";
import { InvoiceStatementCompletePage } from "@/pages/invoiceComplete";
import { InvoiceStatementPage } from "@/pages/invoiceStatement";
import { LabelSupplierPage } from "@/pages/labelSupplier";
import Login from "@/pages/login";
import { LotsPage } from "@/pages/lot";
import { MaintenancePage } from "@/pages/maintenance";
import { MaintenanceCompletePage } from "@/pages/maintenanceComplete";
import { MaintenanceListPage } from "@/pages/maintenanceList";
import { BOMListPage } from "@/pages/masterData/BomList";
import { AbstractItemPage } from "@/pages/masterData/abstractItem";
import { ALCModelPage } from "@/pages/masterData/alcModel";
import { AuthorityPage } from "@/pages/masterData/authority";
import { BOMPage } from "@/pages/masterData/bom";
import { BOMSearchPage } from "@/pages/masterData/bomSearch";
import { CommonCodePage } from "@/pages/masterData/commonCode";
import { Defects } from "@/pages/masterData/defects";
import { DepartmentPage } from "@/pages/masterData/department";
import { DocumentFilePage } from "@/pages/masterData/documentFile";
import { DowntimeReasonsPage } from "@/pages/masterData/downtimeReasons";
import { Equipment } from "@/pages/masterData/equipment";
import { GradePage } from "@/pages/masterData/grade";
import { Item } from "@/pages/masterData/item";
import { ItemCategoryPage } from "@/pages/masterData/itemCategory";
import { LocationPage } from "@/pages/masterData/location";
import { MachinePage } from "@/pages/masterData/machine";
import { MoldPage } from "@/pages/masterData/mold";
import { MoldStockPage } from "@/pages/masterData/moldStock";
import { Operations } from "@/pages/masterData/operations";
import { PartnerPage } from "@/pages/masterData/partner";
import { PeripheralPage } from "@/pages/masterData/peripheral";
import { Routing } from "@/pages/masterData/routing";
import { RoutingOutsourcePage } from "@/pages/masterData/routingOutsource";
import { Site } from "@/pages/masterData/site";
import { Users } from "@/pages/masterData/users";
import { FormExample } from "@/pages/modalExample/form";
import WizardForm from "@/pages/modalExample/wizard";
import { MoldCompleteAdminPage } from "@/pages/moldManagement/completeForAdmin";
import { MoldMaintenancePage } from "@/pages/moldManagement/maintenance";
import { MoldDailyRegisterPage } from "@/pages/moldManagement/moldDailyRegister";
import { MoldDailyStatusPage } from "@/pages/moldManagement/moldDailyStatus";
import { MoldProblemPage } from "@/pages/moldManagement/problem";
import { MoldRepairsPage } from "@/pages/moldManagement/repairs";
import { NotFound } from "@/pages/notFound";
import { WorkByOperationOutsource } from "@/pages/operationOutsourceWorkByRow";
import { OrderCompletePage } from "@/pages/orderComplete";
import { OrderHeadOfficePage } from "@/pages/orderHeadOffice";
import { OutputPage } from "@/pages/output";
import { OverViewPage } from "@/pages/overview";
import { PowerPage } from "@/pages/power";
import { ProductionInspectionPage } from "@/pages/productionInspection";
import { LotTrackingForwardPage } from "@/pages/productionManagement/lotTrackingForward";
import { LotTrackingRevercePage } from "@/pages/productionManagement/lotTrackingReverce";
import { WorkByEquipment } from "@/pages/productionManagement/workByEquipment";
import { WorkByProductionPlan } from "@/pages/productionManagement/workByProductionPlan";
import { WorkByRows } from "@/pages/productionManagement/workByRows";
import { WorkLogPage } from "@/pages/productionManagement/workLog";
import { ProductionPerformancePage } from "@/pages/productionPerformance";
import { ProductionPerformanceOutsourcingPage } from "@/pages/productionPerformanceOutsourcing";
import { PurchaseOrderItemsHeadOfficePage } from "@/pages/purchaseOrderItemsHeadOffice";
import { PurchaseOrderItemsSupplierPage } from "@/pages/purchaseOrderItemsSupplier";
import { InspectSpecificationPage } from "@/pages/qualityManagement/inspect";
import { InspectionRecordsPage } from "@/pages/qualityManagement/inspectionRecords";
import { ChangeListPage } from "@/pages/qualityManagement/quality/changeList";
import { ChangeRegisterInfomationPage } from "@/pages/qualityManagement/quality/changeRegister";
import { DefectStatisticsPage } from "@/pages/qualityManagement/quality/defectStatistics";
import { WorkStandardListPage } from "@/pages/qualityManagement/quality/workStandardList";
import { ReceiptPage } from "@/pages/receipt";
import { ReceivingInspectionPage } from "@/pages/receivingInspection";
import { DeliveryStatusPage } from "@/pages/salesManagement/deliveryStatus";
import { OrderPage } from "@/pages/salesManagement/order";
import { OrderItemsPage } from "@/pages/salesManagement/orderItems";
import { PurchaseOrderPage } from "@/pages/salesManagement/purchaseOrder";
import { PurchaseOrderItemsPage } from "@/pages/salesManagement/purchaseOrderItems";
import { StockPlanPage } from "@/pages/salesManagement/stockPlan";
import { TransportationPage } from "@/pages/salesManagement/transportation";
import { ShipmentReturnPage } from "@/pages/shipmentReturn";
import { ShipmentReceiptPage } from "@/pages/stockManagement/shipmentReceipt";
import { ShipmentRequestPage } from "@/pages/stockManagement/shipmentRequest";
import { ShipmentStatusPage } from "@/pages/stockManagement/shipmentStatus";
import { SystemPage } from "@/pages/systemManagement/system";
import { SystemLogsPage } from "@/pages/systemManagement/systemLogs";
import { SystemParameterPage } from "@/pages/systemManagement/systemParameter";
import { StandardInfoBestPracticePage } from "@/pages/test/StandardInfoBestPractice";
import { UserLogsPage } from "@/pages/userLogs";
import { WorkCompletePage } from "@/pages/workComplete";
import { WorkStandardPage } from "@/pages/workStandard";
import { WorkTimePage } from "@/pages/workTime";
import { useCheckAuth } from "@/utils/checkAuth";

import { WarehousingRegisterPage } from "@/pages/warehousingResigter";
import { Route, Routes, useLocation } from "react-router-dom";
import { purchaseOrderItems } from "@/api/purchaseOrderItems/usePurchaseOrderItems";

// PMS 메뉴 Routes
const pmsMenuRoutes = [
  { path: "/analysis/output", element: <AnalysisOutputPage /> },
  { path: "/analysis/ability", element: <AnalysisAbilityPage /> },
  { path: "/analysis/totaloutput", element: <AnalysisTotalOutputPage /> },
  { path: "/analysis/error", element: <AnalysisErrorPage /> },
  { path: "/analysis/power", element: <AnalysisPowerPage /> },
  { path: "/analysis/idleTime", element: <AnalysisIdleTimePage /> },
  { path: "/analysis/workTime", element: <AnalysisWorkTimePage /> },
  { path: "/press/errorview", element: <PressErrorViewPage /> },
  { path: "/press/parameterview", element: <PressParameterViewPage /> },
  { path: "/press/camview", element: <PressCamViewPage /> },
  { path: "/press/clutchandbrake", element: <PressClutchAndBrakePage /> },
  { path: "/press/facilities", element: <PressFacilitiesPage /> },
  { path: "/press/complete/admin", element: <PressCompleteAdminPage /> },
  { path: "/press/problem", element: <PressProblemPage /> },
  { path: "/press/PressDailyStatus", element: <PressDailyStatusPage /> },
  { path: "/press/PressDailyRegister", element: <PressDailyRegisterPage /> },
  { path: "/mold/maintenance", element: <MoldMaintenancePage /> },
  { path: "/mold/repairs", element: <MoldRepairsPage /> },
  { path: "/mold/complete/admin", element: <MoldCompleteAdminPage /> },
  { path: "/mold/problem", element: <MoldProblemPage /> },
  { path: "/mold/moldDailyRegister", element: <MoldDailyRegisterPage /> },
  { path: "/mold/moldDailyStatus", element: <MoldDailyStatusPage /> },
];

// KPI 메뉴 Routes
const kpiMenuRoutes = [
  { path: "/kpi/leadtime", element: <KPILeadtimePage /> },
  { path: "/kpi/manhour", element: <KPIManhourPage /> },
  { path: "/kpi/defect", element: <KPIDefectPage /> },
  { path: "/kpi/leadtimeOrder", element: <KPILeadTimeOrderPage /> },
  { path: "/kpi/powerUsage", element: <KPIPowerUsagePage /> },
  { path: "/kpi/uph", element: <KPIUPHPage /> },
  { path: "/kpi/rateOfOperation", element: <KPIRateOfOperationPage /> },
];

// 입출고관리 메뉴 Routes
const storageManagementMenuRoutes = [
  { path: "/shipment-request", element: <ShipmentRequestPage /> },
  { path: "/shipment-receipt", element: <ShipmentReceiptPage /> },
  { path: "/shipment-status", element: <ShipmentStatusPage /> },
];

// 설비모니터링 메뉴 Routes
const equipmentMonitoringRoutes = [
  { path: "/analysisMonitoring", element: <AnalysisMonitoringPage /> },
  { path: "/errorView", element: <ErrorViewPage /> },
  { path: "/maintenance", element: <MaintenancePage /> },
  { path: "/maintenanceList", element: <MaintenanceListPage /> },
  { path: "/maintenanceComplete", element: <MaintenanceCompletePage /> },
  { path: "/equipmentProblem", element: <EquipmentProblemPage /> },
  { path: "/dailyRegister", element: <DailyRegisterPage /> },
  { path: "/dailyList", element: <DailyListPage /> },
  { path: "/output", element: <OutputPage /> },
  { path: "/error", element: <ErrorPage /> },
  { path: "/power", element: <PowerPage /> },
  { path: "/idleTime", element: <IdleTimePage /> },
  { path: "/workTime", element: <WorkTimePage /> },
];
// 시스템 메뉴 Routes
const systemMenuRoutes = [
  { path: "/system", element: <SystemPage /> },
  { path: "/system-logs", element: <SystemLogsPage /> },
  { path: "/system-parameter", element: <SystemParameterPage /> },
];

const RoutePaths = [
  { path: "/dashboard", element: <MainDashboard /> },
  ...(customFunctions.ADD_USER_ACCESS_STATUS
    ? [{ path: "/userLogs", element: <UserLogsPage /> }]
    : []),
  { path: "/work-by-equipment", element: <WorkByEquipment /> },
  { path: "/work-by-production-plan", element: <WorkByProductionPlan /> },
  { path: "/work-by-row", element: <WorkByRows /> },
  ...(customFunctions.ADD_SHOW_OPERATION_OUTSOURCING_WORK
    ? [
        {
          path: "/operation-outsource-work-by-row",
          element: (
            <CheckboxProvider>
              <WorkByOperationOutsource />
            </CheckboxProvider>
          ),
        },
      ]
    : []),
  {
    path: "/lotForward",
    element: (
      <LotTrackingProvider>
        <LotTrackingForwardPage />
      </LotTrackingProvider>
    ),
  },
  {
    path: "/lotReverce",
    element: (
      <LotTrackingProvider>
        <LotTrackingRevercePage />
      </LotTrackingProvider>
    ),
  },
  { path: "/production-plan-with-works-form", element: <ProductionPlanCreateForm /> },
  ...(customFunctions.ADD_MONITORING_MENU_SETTING ||
  customFunctions.ADD_EQUIPMENT_MONITORING_MENU_SETTING
    ? [{ path: "/overview", element: <OverViewPage /> }]
    : []),
  ...(customFunctions.ADD_MONITORING_MENU_SETTING ||
  customFunctions.ADD_PMS_MENU_SETTING ||
  customFunctions.ADD_EQUIPMENT_MONITORING_MENU_SETTING
    ? [{ path: "/monitoring", element: <MonitoringPage /> }]
    : []),
  { path: "/orderItems", element: <OrderItemsPage /> },
  { path: "/stockPlan", element: <StockPlanPage /> },
  { path: "/transportation", element: <TransportationPage /> },
  ...(customFunctions.ADD_STANDARD_INFO_COMMON_CODE_MENU_SETTING
    ? [{ path: "/common-code", element: <CommonCodePage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_AUTH_GROUP_MENU_SETTING
    ? [{ path: "/authority", element: <AuthorityPage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_ALC_MODEL_MENU_SETTING
    ? [{ path: "/ALCmodel", element: <ALCModelPage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_BOM_MENU_SETTING
    ? [{ path: "/bom", element: <BOMPage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_BOM_LIST_MENU_SETTING
    ? [{ path: "/bomList", element: <BOMListPage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_FILE_MENU_SETTING
    ? [{ path: "/document-file", element: <DocumentFilePage /> }]
    : []),
  { path: "/downtimeReasons-log", element: <DownTimeReasonsLogPage /> },
  ...(customFunctions.ADD_LACK_SAFETY_MENU_SETTING
    ? [{ path: "/lackSafety", element: <LackSafetyPage /> }]
    : []),
  ...(customFunctions.ADD_INVENTORY_LIFE_MENU_SETTING
    ? [{ path: "/inventoryLife", element: <InventoryLifePage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_PERIPHERAL_MENU_SETTING
    ? [{ path: "/peripheral", element: <PeripheralPage /> }]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_MACHINE_MENU_SETTING
    ? [{ path: "/machine", element: <MachinePage /> }]
    : []),
  ...(customFunctions.ADD_PMS_PRESS_MONITORING || customFunctions.ADD_PMS_MENU_SETTING
    ? [{ path: "/pressMonitoring/factoryMonitoring", element: <PressMonitoringFactoryPage /> }]
    : []),
  { path: "/pressMonitoring/factoryMonitoring/pageSetting", element: <FactoryPageSetting /> },
  ...(customFunctions.ADD_DATA_DISPLAY_MENU_SETTING && customFunctions.ADD_KPI_MENU_SETTING
    ? [{ path: "/dataDisplay", element: <DataDisplayPage /> }]
    : []),
  ...(customFunctions.ADD_DASHBOARD_EQUIPMENT_ANALYSIS
    ? [{ path: "/equipmentAnalysis", element: <EquipmentAnalysisPage /> }]
    : []),
  ...(customFunctions.ADD_DEFECT_STATISTICS_MENU_SETTING
    ? [{ path: "/quality/defect-statistics", element: <DefectStatisticsPage /> }]
    : []),
  ...(customFunctions.ADD_WORK_STANDARD_DOCUMENT_LIST_MENU_SETTING
    ? [{ path: "/quality/work-standardList", element: <WorkStandardListPage /> }]
    : []),
  ...(customFunctions.ADD_CHANGE_LIST_MENU_SETTING
    ? [{ path: "/quality/change-list", element: <ChangeListPage /> }]
    : []),
  { path: "/quality/change-register", element: <ChangeRegisterInfomationPage /> },
  // { path: "/quality/pre-warehouseList", element: <PreWareHouseListPage /> },
  ...(customFunctions.ADD_PERFORMANCE_MENU_SETTING
    ? [{ path: "/productionpreformance", element: <ProductionPerformancePage /> }]
    : []),
  ...(customFunctions.ADD_PERFORMANCE_OUTSOURCING_MENU_SETTING
    ? [
        {
          path: "/productionperformanceOutsourcing",
          element: <ProductionPerformanceOutsourcingPage />,
        },
      ]
    : []),
  ...(customFunctions.ADD_PMS_MENU_SETTING ? pmsMenuRoutes : []),
  ...(customFunctions.ADD_KPI_MENU_SETTING ? kpiMenuRoutes : []),
  ...(customFunctions.ADD_EQUIPMENT_MONITORING_MENU_SETTING ? equipmentMonitoringRoutes : []),
  ...(customFunctions.ADD_SYSTEM_MANAGEMENT_MENU_SETTING ? systemMenuRoutes : []),
  ...(customFunctions.ADD_STORAGE_MANAGEMENT_MENU_SETTING ? storageManagementMenuRoutes : []),

  { path: "/wizard", element: <WizardForm /> },
  { path: "/form", element: <FormExample /> },
  { path: "/modal-multi", element: <ModalExample /> },

  { path: "/purchaseOrderItems-head-office", element: <PurchaseOrderItemsHeadOfficePage /> },
  { path: "/deliveryStatus-head-office", element: <DeliveryStatusHeadOfficePage /> },
  { path: "/deliveryList-company", element: <DeliveryListCompanyPage /> },
  { path: "/deliveryList-head-office", element: <DeliveryListHeadOfficePage /> },
  { path: "/order-head-office", element: <OrderHeadOfficePage /> },
  { path: "/purchaseOrderItems-supplier", element: <PurchaseOrderItemsSupplierPage /> },
  { path: "/deliveryStatus-supplier", element: <DeliveryStatusSupplierPage /> },
  { path: "/deliveryList-supplier", element: <DeliveryListSupplierPage /> },

  { path: "/shipment-request-supplier", element: <ShipmentRequestPage /> },
  { path: "/shipment-status-supplier", element: <ShipmentStatusPage /> },

  { path: "/label-supplier", element: <LabelSupplierPage /> },
  { path: "/shipment-return", element: <ShipmentReturnPage /> },
  { path: "/work-standard", element: <WorkStandardPage /> },
  { path: "/changePoint", element: <ChangePointPage /> },
  { path: "/changePointList", element: <ChangePointListPage /> },
  { path: "/receivingInspection", element: <ReceivingInspectionPage /> },
  { path: "/productionInspection", element: <ProductionInspectionPage /> },
  { path: "/work-complete", element: <WorkCompletePage /> },
  { path: "/receipt", element: <ReceiptPage /> },
  { path: "/barcodeLift", element: <BarcodeLiftPage /> },
  { path: "/barcodeMerge", element: <BarcodeMergePage /> },
  { path: "/warehousingRegister", element: <WarehousingRegisterPage /> },
];

// 기준정보 메뉴 Paths
const StandardInfoPath = [
  {
    path: "/items",
    element: <Item />,
    queryKeyFactory: customFunctions.ADD_STANDARD_INFO_GRADE_MENU_SETTING
      ? items.getView
      : items.get,
    searchFieldsHeader: itemsHeader,
  },
  {
    path: "/equipment",
    element: <Equipment />,
    queryKeyFactory: equipments.get,
    searchFieldsHeader: equipmentsHeader,
    populate: ["works", "location"],
  },
  {
    path: "/defects",
    element: <Defects />,
    queryKeyFactory: defects.get,
    searchFieldsHeader: defectsHeader,
  },
  {
    path: "/operations",
    element: <Operations />,
    queryKeyFactory: operations.get,
    searchFieldsHeader: operationsHeader,
    populate: ["location"],
  },
  {
    path: "/routing",
    element: <Routing />,
    queryKeyFactory: routings.get,
    searchFieldsHeader: routingsHeader,
    populate: ["item", "operation", "mold"],
  },
  {
    path: "/users",
    element: <Users />,
    queryKeyFactory: users.get,
    searchFieldsHeader: usersHeader,
  },
  {
    path: "/site",
    element: <Site />,
    queryKeyFactory: sites.get,
    searchFieldsHeader: sitesHeader,
  },
  {
    path: "/location",
    element: <LocationPage />,
    queryKeyFactory: locations.get,
    searchFieldsHeader: locationsHeader,
  },
  {
    path: "/routing-outsource",
    element: <RoutingOutsourcePage />,
    queryKeyFactory: routingOutsources.get,
    searchFieldsHeader: routingOutsourcesHeader,
    populate: ["location"],
  },
  {
    path: "/mold",
    element: <MoldPage />,
    queryKeyFactory: molds.get,
    searchFieldsHeader: moldsHeader,
  },
  {
    path: "/moldStock",
    element: <MoldStockPage />,
    queryKeyFactory: moldStocks.get,
    searchFieldsHeader: moldStocksHeader,
  },
  {
    path: "/abstract-item",
    element: <AbstractItemPage />,
    queryKeyFactory: abstractItems.get,
    searchFieldsHeader: abstractItemsHeader,
  },
  {
    path: "/item-category",
    element: <ItemCategoryPage />,
    queryKeyFactory: itemCategories.get,
    searchFieldsHeader: itemCategoriesHeader,
  },
  {
    path: "/downtimeReasons",
    element: <DowntimeReasonsPage />,
    queryKeyFactory: downtimeReasons.get,
    searchFieldsHeader: downtimeReasonsHeader,
  },
  ...(customFunctions.ADD_STANDARD_INFO_GRADE_MENU_SETTING
    ? [
        {
          path: "/grade",
          element: <GradePage />,
          queryKeyFactory: grades.get,
          searchFieldsHeader: gradesHeader,
        },
      ]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_DEPART_CODE_MENU_SETTING
    ? [
        {
          path: "/department",
          element: <DepartmentPage />,
          queryKeyFactory: department.get,
          searchFieldsHeader: departmentHeader,
        },
      ]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_PARTNER_MENU_SETTING
    ? [
        {
          path: "/partner",
          element: <PartnerPage />,
          queryKeyFactory: partners.get,
          searchFieldsHeader: partnersHeader,
        },
      ]
    : []),
  ...(customFunctions.ADD_STANDARD_INFO_BOM_SEARCH_MENU_SETTING
    ? [
        {
          path: "/bomSearch",
          element: <BOMSearchPage />,
          queryKeyFactory: customFunctions.ADD_STANDARD_INFO_GRADE_MENU_SETTING
            ? items.getView
            : items.get,
          searchFieldsHeader: itemsBomHeader,
        },
      ]
    : []),

  // 추가 라우트 정의 ...
  ...(customFunctions.ADD_BEST_PRACTICE_TEST_MENU_SETTING
    ? [
        {
          path: "/test-standard-info-best-practice",
          element: <StandardInfoBestPracticePage />,
          queryKeyFactory: items.get,
          searchFieldsHeader: itemsHeader,
        },
      ]
    : []),
  // 추가 라우트 정의 ...
];

const ProductionManagementPath = [
  {
    path: "/work-log",
    element: <WorkLogPage />,
    queryKeyFactory: workLogsWorks.get,
    searchFieldsHeader: workLogHeader,
    populate: [
      "itemUnit",
      "itemData",
      "routing",
      "defectName",
      "alreadyCanceled",
      "creatorUser",
      "downtimeReasonName",
      "getEquipment",
      "currentLotSummary",
    ],
    isUseDate: true,
  },
];

const InventoryControlPath = [
  {
    path: "/inventory",
    element: <InventoryPage />,
    queryKeyFactory: inventories.betweenGet,
    searchFieldsHeader: inventoriesHeader,
    populate: ["lot", "location", "item"],
    isUseParams: true,
    isUseDate: true,
  },
  {
    path: "/ledgersAll",
    element: <LedgerAllPage />,
    queryKeyFactory: ledgers.get,
    searchFieldsHeader: LedgersHeader,
    populate: ["item", "location", "name"],
    isUseDate: true,
  },
  {
    path: "/wipInventory",
    element: <WipInventoryPage />,
    queryKeyFactory: wipInventory.get,
    searchFieldsHeader: wipInventoriesHeader,
    populate: ["productionPlans", "itemUnit"],
  },
  {
    path: "/wmsLogs",
    element: <WmsLogsPage />,
    queryKeyFactory: wmsLog.get,
    searchFieldsHeader: wmsLogsHeader,
    populate: ["locationName", "lot"],
  },
  {
    path: "/lots",
    element: <LotsPage />,
    queryKeyFactory: lots.get,
    searchFieldsHeader: lotsHeader,
    populate: [],
  },
];

const SalesManagementPath = [
  {
    path: "/purchaseOrder",
    element: <PurchaseOrderPage />,
    queryKeyFactory: purchaseOrders.get,
    searchFieldsHeader: purchaseOrderItemsHeader,
    populate: ["location", "user", "partner", "purchaseOrderItems"],
  },
  {
    path: "/purchaseOrderItems",
    element: <PurchaseOrderItemsPage />,
    queryKeyFactory: purchaseOrderItems.get,
    searchFieldsHeader: purchaseOrderItemsHeader,
    populate: ["itemName", "user", "quantities", "location", "partner", "purchaseOrderCode"],
  },
  {
    path: "/deliveryStatus",
    element: <DeliveryStatusPage />,
    queryKeyFactory: wmsLog.get,
    searchFieldsHeader: purchaseOrderItemsHeader,
    populate: ["locationName", "purchaseOrderItem", "lot"],
  },
];

const QualityControlPath = [
  ...(customFunctions.ADD_QUALITY_MENU_SETTING
    ? [
        {
          path: "/inspectSpecification",
          element: <InspectSpecificationPage />,
          queryKeyFactory: specifications.get,
          searchFieldsHeader: specificationsHeader,
          populate: ["lot"],
        },
      ]
    : []),
  ...(customFunctions.ADD_QUALITY_MENU_SETTING
    ? [
        {
          path: "/inspectionRecords",
          element: <InspectionRecordsPage />,
          queryKeyFactory: inspections.get,
          searchFieldsHeader: specificationsHeader,
          populate: ["lot"],
        },
      ]
    : []),
];

const purchaseOrderPath = [
  // 발주 완료 페이지
  ...(customFunctions.ADD_ORDER_COMPLETE_MENU_SETTING
    ? [
        {
          path: "/orderComplete",
          element: <OrderCompletePage />,
          queryKeyFactory: purchaseOrders.complete,
          searchFieldsHeader: orderHeader,
          populate: ["location", "user", "partner", "purchaseOrderItems"],
        },
      ]
    : []),
  // 발주 페이지
  {
    path: "/order",
    element: <OrderPage />,
    queryKeyFactory: purchaseOrders.order,
    searchFieldsHeader: orderHeader,
    populate: ["location", "user", "partner", "purchaseOrderItems", "purchaseOrderItemQty"],
  },
  ...(customFunctions.ADD_INVOICE_STATEMENT_MENU_SETTING
    ? [
        // 거래명세서 페이지
        {
          path: "/invoiceStatement",
          element: <InvoiceStatementPage />,
          queryKeyFactory: invoice.get,
          searchFieldsHeader: invoiceStatementHeader,
          populate: [
            "populateLocationName",
            "populateUserName",
            "populateNumberOfInvoiceItems",
            "invoiceItems",
          ],
        },
        // 거래명세서 완료 페이지
        {
          path: "/invoiceStatementComplete",
          element: <InvoiceStatementCompletePage />,
          queryKeyFactory: invoice.complete,
          searchFieldsHeader: invoiceStatementHeader,
          populate: [
            "populateLocationName",
            "populateUserName",
            "populateNumberOfInvoiceItems",
            "invoiceItems",
          ],
        },
      ]
    : []),
];

function RoutesConfig() {
  const location = useLocation();
  const auth = useCheckAuth();

  return (
    <Routes location={location}>
      <Route element={<Layout auth={auth} />}>
        <Route
          path="/"
          element={
            <ProtectedRoute redirectCondition={auth} redirectPath={"/dashboard"}>
              <Login />
            </ProtectedRoute>
          }
        />
        {RoutePaths.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                {route.element}
              </ProtectedRoute>
            }
          />
        ))}
        {StandardInfoPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        {QualityControlPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        {InventoryControlPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                  isUseParams={route.isUseParams}
                  isUseDate={route.isUseDate}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        {SalesManagementPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        {purchaseOrderPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        {ProductionManagementPath.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute redirectCondition={!auth} redirectPath={"/"}>
                <StandardLayoutProvider
                  key={route.path}
                  populate={route.populate}
                  queryKeyFactory={route.queryKeyFactory}
                  searchFieldsHeader={route.searchFieldsHeader}
                  isUseDate={route.isUseDate}
                >
                  {route.element}
                </StandardLayoutProvider>
              </ProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default RoutesConfig;
